// i18next-extract-mark-ns-start Step1
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'gatsby-plugin-react-i18next';

import withOrderContext from '../../withOrderContext';
import withAppContext from '../../withAppContext';

import {
  tabletThresholdPixels,
  Button as ButtonV3, frames,
} from '../home/v3/styledComponents';
import { colors } from '../home/v4/styledComponents';
import { Subtitle } from './orderStyledComponents';
import { formatPrice } from '../../services/pricing';

import OrderSummaryAtHome from './OrderSummaryAtHome';
import OrderSummaryPackage from './OrderSummaryPackage';
import OrderSummaryPromoCode from './OrderSummaryPromoCode';
import ReInsuranceInfos from './ReInsuranceInfos';

const Container = styled.div`
  width: ${({ vertical }) => vertical ? '350px' : '100%'};
  box-sizing: border-box;
  ${({ lastStep }) => !lastStep && '  height: 100%;'}
  background-color: ${colors.beige100};
  text-align: left;
  color: ${colors.black};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
  }
`;
const StyledTitle = styled(Subtitle)`
  font-size: ${({ vertical }) => vertical ? 22 : 96}px;
  margin-bottom: ${({ vertical }) => vertical ? 25 : 0}px;
  ${({ vertical }) => vertical && 'font-family: Space Mono; font-weight: 400;'}
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: ${({ vertical }) => vertical ? 20 : 40}px;
    ${({ vertical }) => vertical && 'margin-left: 17px;'}
    margin-bottom: ${({ vertical }) => vertical ? 25 : 0}px;
  }
`;
const OrderContainer1 = styled.div`
  padding: ${({ vertical }) => vertical ? '0px' : '64px 68px 25px'};
  @media (max-width: ${tabletThresholdPixels}) {
    padding: ${({ vertical }) => vertical ? '0px' : '20px 27px'};
    margin-top: ${({ vertical }) => vertical && '40px'};
    width: calc(100vw - (${frames.mobile}*2));
    ${({ vertical }) => !vertical && 'height: 425px; overflow-y: scroll;'}
  }
`;
const OrderContainer2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ vertical }) => !vertical && `background-color: ${colors.beige200}; padding: 0px 68px 50px;`}
  @media (max-width: ${tabletThresholdPixels}) {
    flex-direction: column;
    ${({ vertical }) => !vertical && 'padding: 0px 27px 20px;'}
    width: calc(100vw - (${frames.mobile}*2));
  }
`;
const SubContainer = styled.div`
  @media (max-width: ${tabletThresholdPixels}) {
    width: unset;
  }
`;
const TotalRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: 700;
  font-size: 18px;
  text-transform: uppercase;
  margin: 32px 0;
  padding: ${({ vertical }) => vertical ? '0 20px' : '0 17px'};
  ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom};`}
  ${({ grey }) => grey && `color: ${colors.grey200}; `}

  @media (max-width: ${tabletThresholdPixels}) {
    margin: 20px 0px;
    ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom};`}
    padding: 0 12px;
  }
`;
const LittleTotalRow = styled(TotalRow)`
  font-size: 16px;
  text-transform: uppercase;
  padding: 0 20px;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 15px;
  }
`;
const SubTotalRow = styled(TotalRow)`
  font-size: 13px;
  font-weight: 400;
  margin-top: 0px;
  padding: 0 20px;
  text-transform: none;
  ${({ grey }) => grey && `color: ${colors.grey200}; margin-top: -15px;`}
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 12px;
    line-height: 17px;
    ${({ grey }) => grey && `color: ${colors.grey200}; margin-top: -5px;`}
  }
`;
const Line = styled.div`
  border-width: 0.5px;
  border-style: solid;
  ${({ marginTop }) => marginTop && `margin-top: ${marginTop}px;`}
  ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom}px;`}
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 20px 0px 0px;
  }
`;
const Span = styled.span`
  color: ${colors.grey504};
  font-size: 16px;
`;
const TransformationText = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 14px;
  }
`;
const StyledLink = styled.div`
  text-decoration: none;
  @media (max-width: ${tabletThresholdPixels}) {
  width: 100%;
  }
`;
const ButtonModal = styled(ButtonV3)`
  width: 257px;
  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
    margin-bottom: 14px;
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  @media (max-width: ${tabletThresholdPixels}) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

const renderMinOrderAmount = (t, minOrderAmountFee, minOrderAmount, hasUpcycling, currency) => {
  if (minOrderAmountFee > 0) {
    return (
      <div>
        <LittleTotalRow grey>
          {t('Minimum de commande')}
          <span>{`${formatPrice(minOrderAmount || 20, currency)}`}</span>
        </LittleTotalRow>
        <SubTotalRow grey>
          {`${t('Nos Tillistes se déplacent pour un minimum de')} ${formatPrice(minOrderAmount || 20, currency)}`}
          {hasUpcycling
            ? t(", d'ici votre rendez-vous, vous trouverez bien un vêtement qui a besoin d'un coup de neuf :)")
            : ''}
        </SubTotalRow>
      </div>
    );
  }
  return null;
};

const renderTotalEstimated = (t, vertical, hasDefinedPrice, hasUpcyclingWithoutPriceRange, totalPaid, totalPaidStep1, discountVouchersValue, currency) => {
  if (!hasDefinedPrice) {
    return (
      <TotalRow vertical={vertical}>
        {t('Total estimé')}
        <Span>{t(' Estimation en RDV')}</Span>
      </TotalRow>
    );
  }
  return (
    <TotalRow vertical={vertical}>
      {t('Total estimé')}
      {vertical ? (
        <span>
          {totalPaid - discountVouchersValue > 0
            ? formatPrice(totalPaid - discountVouchersValue, currency)
            : formatPrice(0, currency)}
          {hasUpcyclingWithoutPriceRange ? t(' + estimation en RDV') : ''}
        </span>
      ) : (
        <span>{formatPrice(totalPaidStep1 - discountVouchersValue, currency)}</span>
      )}
    </TotalRow>
  );
};

class OrderSummary extends React.Component {
  componentDidMount() {
    const { trackTotalPaid, totalPaid, onTotalPaid } = this.props;
    if (!Number.isNaN(totalPaid)) {
      onTotalPaid(totalPaid);
      trackTotalPaid(totalPaid);
    }
  }

  componentDidUpdate() {
    const { trackTotalPaid, totalPaid, onTotalPaid } = this.props;
    if (!Number.isNaN(totalPaid)) {
      onTotalPaid(totalPaid);
      trackTotalPaid(totalPaid);
    }
  }

  render() {
    const {
      totalClothes, total, totalPaid, totalPaidBrand, minOrderAmountFee, minOrderAmount, selectedDates,
      clothes, promoCode, setInputPromoCode, checkPromoCode, selectedAddress, rawClothes, deleteCloth, duplicateCloth, isAdviceOrder, vertical, lastStep, setEditingClothIndex,
      errorPromoCode, hasDefinedPrice, discountVouchersValue, hasZipcode, isPromoCodeDisplayed,
      isAddingNewAddress, totalPaidStep1, isSelectingDone, displayButtons,
      addPiece, setIsOrderSummaryModalOpened, goNext, removePromoCode, t, repairBonus,
      orderContext: {
        relayPoint, transporter, isDoubleProcess, deliveryFee, editingClothIndex, pricingInverse, leatherGoodsPricingInverse, category, discounts, isOnlyRemaillage,
        transporterInsurance, currency,
      },
    } = this.props;
    const hasUpcycling = clothes
      .reduce((acc, cloth) => acc || cloth.typeOfWork === 'transformation', false);
    const hasUpcyclingWithoutPriceRange = clothes
      .reduce((acc, cloth) => acc || (cloth.typeOfWork === 'transformation' && cloth.upcyclingItems.length === 0), false);
    const clothesPackage = clothes.filter((cloth) => cloth.process === 'PACKAGE');
    const clothesAtHome = clothes.filter((cloth) => cloth.process !== 'PACKAGE');
    return (
      <Container vertical={vertical} lastStep={lastStep}>
        <OrderContainer1 vertical={vertical}>
          <StyledTitle left vertical={vertical}>
            {vertical ? t('Récapitulatif') : t('Estimation')}
          </StyledTitle>
          <ReInsuranceInfos clothesPackage={clothesPackage} clothesAtHome={clothesAtHome} isDoubleProcess={isDoubleProcess} vertical={vertical} />
          {hasUpcycling
              && (
                <TransformationText>
                  {t('Pour les transformations, le couturier réalisera le devis directement sur place.')}
                  <br />
                  {t('C’est lui le mieux placé pour vous recommander les travaux de couture à effectuer :)')}
                </TransformationText>
              )}

          {clothesAtHome.length > 0 && (
            <OrderSummaryAtHome
              vertical={vertical}
              selectedAddress={selectedAddress}
              lastStep={lastStep}
              isAddingNewAddress={isAddingNewAddress}
              selectedDates={selectedDates}
              clothesAtHome={clothesAtHome}
              isDoubleProcess={isDoubleProcess}
              hasDefinedPrice={hasDefinedPrice}
              totalClothes={totalClothes}
              hasUpcyclingWithoutPriceRange={hasUpcyclingWithoutPriceRange}
              promoCode={promoCode}
              hasZipcode={hasZipcode}
              deliveryFee={deliveryFee}
              discounts={discounts}
              rawClothes={rawClothes}
              deleteCloth={deleteCloth}
              duplicateCloth={duplicateCloth}
              editingClothIndex={editingClothIndex}
              setEditingClothIndex={setEditingClothIndex}
              isAdviceOrder={isAdviceOrder}
              pricingInverse={['accessories', 'shoes'].includes(category) ? leatherGoodsPricingInverse : pricingInverse}
              currency={currency}
            />
          )}

          {clothesPackage.length > 0 && (
            <OrderSummaryPackage
              vertical={vertical}
              selectedAddress={selectedAddress}
              isAddingNewAddress={isAddingNewAddress}
              isDoubleProcess={isDoubleProcess}
              relayPoint={relayPoint}
              transporter={transporter}
              selectedDates={selectedDates}
              lastStep={lastStep}
              clothesPackage={clothesPackage}
              hasDefinedPrice={hasDefinedPrice}
              totalClothes={totalClothes}
              hasUpcyclingWithoutPriceRange={hasUpcyclingWithoutPriceRange}
              promoCode={promoCode}
              deliveryFee={deliveryFee}
              discounts={discounts}
              rawClothes={rawClothes}
              deleteCloth={deleteCloth}
              duplicateCloth={duplicateCloth}
              editingClothIndex={editingClothIndex}
              setEditingClothIndex={setEditingClothIndex}
              isAdviceOrder={isAdviceOrder}
              pricingInverse={['accessories', 'shoes'].includes(category) ? leatherGoodsPricingInverse : pricingInverse}
              isOnlyRemaillage={isOnlyRemaillage}
              transporterInsurance={transporterInsurance}
              currency={currency}
            />
          )}
          {lastStep && <Line marginTop={25} />}
          <SubContainer vertical={vertical}>
            {renderMinOrderAmount(t, minOrderAmountFee, minOrderAmount, hasUpcycling, currency)}
            <OrderSummaryPromoCode
              promoCode={promoCode}
              vertical={vertical}
              total={total}
              totalPaid={totalPaid}
              lastStep={lastStep}
              removePromoCode={removePromoCode}
              isPromoCodeDisplayed={isPromoCodeDisplayed}
              totalPaidBrand={totalPaidBrand}
              discountVouchersValue={discountVouchersValue}
              setInputPromoCode={setInputPromoCode}
              checkPromoCode={checkPromoCode}
              errorPromoCode={errorPromoCode}
              currency={currency}
              repairBonus={repairBonus}
            />
          </SubContainer>
        </OrderContainer1>

        <OrderContainer2 vertical={vertical}>
          {((!lastStep && !vertical) || isDoubleProcess) && <Line marginTop={25} marginBottom={0} />}
          {renderTotalEstimated(t, vertical, hasDefinedPrice, hasUpcyclingWithoutPriceRange, totalPaid, totalPaidStep1, discountVouchersValue, currency)}

          {(!vertical && (isSelectingDone || displayButtons)) && (
            <ButtonContainer>
              <ButtonModal
                onClick={() => {
                  addPiece();
                  setIsOrderSummaryModalOpened(false);
                }}
                transparent
              >
                {t('+ Ajouter une pièce')}
              </ButtonModal>
              <StyledLink onClick={goNext}>
                <ButtonModal black data-cy="last-step">{t('Continuer')}</ButtonModal>
              </StyledLink>
            </ButtonContainer>
          )}
        </OrderContainer2>
      </Container>
    );
  }
}

OrderSummary.propTypes = {
  minOrderAmountFee: PropTypes.number.isRequired,
  minOrderAmount: PropTypes.number.isRequired,
  totalClothes: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  totalPaid: PropTypes.number.isRequired,
  totalPaidBrand: PropTypes.number.isRequired,
  totalPaidStep1: PropTypes.number.isRequired,
  clothes: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string,
    })),
    typeOfWork: PropTypes.string,
    total: PropTypes.number.isRequired,
  })),
  selectedDates: PropTypes.shape({}),
  selectedAddress: PropTypes.shape({}),
  vertical: PropTypes.bool,
  promoCode: PropTypes.shape({
    value: PropTypes.number,
    code: PropTypes.string,
    unit: PropTypes.string,
    doesTilliOfferDeliveryFees: PropTypes.bool,
    brand: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  setInputPromoCode: PropTypes.func.isRequired,
  checkPromoCode: PropTypes.func.isRequired,
  errorPromoCode: PropTypes.bool,
  setEditingClothIndex: PropTypes.func.isRequired,
  deleteCloth: PropTypes.func.isRequired,
  orderContext: PropTypes.shape({
    editingClothIndex: PropTypes.number,
    pricingInverse: PropTypes.shape({}).isRequired,
    relayPoint: PropTypes.shape({
      name: PropTypes.string,
    }),
    transporter: PropTypes.string,
    leatherGoodsPricingInverse: PropTypes.shape({}).isRequired,
    category: PropTypes.string,
    isDoubleProcess: PropTypes.bool,
    deliveryFee: PropTypes.shape({
      packageFee: PropTypes.number,
      atHomeFee: PropTypes.number,
      total: PropTypes.number,
    }),
    currency: PropTypes.string,
    discounts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.number,
      unit: PropTypes.string,
      code: PropTypes.string,
      brand: PropTypes.shape({
        name: PropTypes.string,
      }),
    })),
    isOnlyRemaillage: PropTypes.bool,
    transporterInsurance: PropTypes.shape({}),
  }).isRequired,
  hasDefinedPrice: PropTypes.bool,
  discountVouchersValue: PropTypes.number.isRequired,
  hasZipcode: PropTypes.bool,
  isPromoCodeDisplayed: PropTypes.bool,
  trackTotalPaid: PropTypes.func,
  onTotalPaid: PropTypes.func,
  duplicateCloth: PropTypes.func,
  rawClothes: PropTypes.arrayOf(PropTypes.shape({})),
  isAdviceOrder: PropTypes.bool,
  lastStep: PropTypes.bool,
  context: PropTypes.shape({
    isMobile: PropTypes.bool,
  }).isRequired,
  isAddingNewAddress: PropTypes.bool,
  isSelectingDone: PropTypes.bool,
  displayButtons: PropTypes.bool,
  addPiece: PropTypes.func,
  setIsOrderSummaryModalOpened: PropTypes.func,
  goNext: PropTypes.func,
  removePromoCode: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  repairBonus: PropTypes.number,
};

OrderSummary.defaultProps = {
  duplicateCloth() {},
  rawClothes: [],
  selectedDates: null,
  selectedAddress: null,
  vertical: false,
  clothes: [],
  promoCode: null,
  errorPromoCode: false,
  hasDefinedPrice: false,
  hasZipcode: false,
  isPromoCodeDisplayed: true,
  trackTotalPaid() { },
  onTotalPaid() { },
  isAdviceOrder: false,
  lastStep: false,
  isAddingNewAddress: false,
  isSelectingDone: false,
  displayButtons: false,
  repairBonus: 0,
  addPiece: () => { },
  setIsOrderSummaryModalOpened: () => { },
  goNext: () => { },
};

export default withTranslation()(withAppContext(withOrderContext(OrderSummary)));
